<template>
  <div class="detailpage" v-if="cruiseDetail && cruiseDetail.cruiseId > 0">
    <div class="banner">
      <BannerKV :banners="banners" :autoplay="true" :vrUrl="vrUrl"/>
      <div v-if="cruiseDetail.isShowDeadlineSaleCountdown" class='salesCountdownBox'>
        <div class="barDesc">距关闭仅剩</div>
        <uCountDown :timestamp="cruiseDetail.deadlineSaleCountdownTotalSeconds"/>
      </div>
    </div>
    <div class="warp1200">
      <CruiseDetailCruiseInfo
        :cruiseDetail="cruiseDetail"
        :showLoginPopup="showLoginPopup"
        :couponsList="couponsList"
      />

      <CruiseDetailStateroom
        :cruiseDetail="cruiseDetail"
        :showLoginPopup="showLoginPopup"
        :specialBookingInfo="specialBookingInfo"
        :showRow="true"
      />

      <!--特殊礼遇-生日-->
      <div v-if="bannerIncludesBirthdayList && bannerIncludesBirthdayList.length > 0" class="specialBookingMobileBanner">
        <CustomBannerSwiper class="cruiseDetail-middle-banner"
                            :bannerList="bannerIncludesBirthdayList"
                            :autoplay="true"
                            :isShowDot="true"
                            @on-jump="handleBannerToJump"></CustomBannerSwiper>
      </div>

      <CruiseDetailNav
        :shoppingCarts="shoppingCarts"
        :isShowReview="reviews.length > 0"
        :isFeaturesShow="featuresUrls.length > 0"
      />
      <CruiseDetailFeatures v-if="featuresUrls.length > 0" ref="CruiseDetailFeatures" :featuresUrls="featuresUrls" />
      <CruiseDetailRoute
        ref="CruiseDetailRoute"
        :ports="ports"
        :shipCode="shipCode"
        :sailDate="sailDate"
        :payShorexOnly="payShorexOnly"
        :showRow="true"
      />
      <div v-if="vrUrl && vrUrl.length>0" class="vrBanner">
        <a :href="vrUrl" target="_blank">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/cruiseVrBanner.png" alt="" title="点击进入VR全景看光谱">
        </a>
      </div>
      <CruiseDetailPolicy
        ref="CruiseDetailPolicy"
        :visaContent="cruiseDetail.visaContent"
        :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
        :isSevenDayNrpCruise="cruiseDetail.isSevenDayNrpCruise"
        :departureCode="departureCode"
        :shipCode="shipCode"
        :sailDate="sailDate"
        :shipName="cruiseDetail.shipName"
        :portAddress="portAddress"
        :customClass="'cruiseDetail'"
        :specialBookingInfo="specialBookingInfo"
        :isDownPayCruise="cruiseDetail.isDownPayCruise"
        :showRow="true"
      />

      <div class="part5 Review" id="section7" v-if="reviews.length > 0">
        <div class="blur_bd_title">达人<br />游记</div>
        <div class="part5_bd travels_box">
          <ul class="row">
            <li
              class="col-lg-3 col-sm-3 col-md-3 col-xs-3"
              v-for="review in reviews"
              :key="'review_' + review.id"
              @click.prevent="goReviewDetail(review.id)"
            >
              <div class="list_box review">
                <div class="list_img">
                  <img :src="review.iconImage" alt="" />
                </div>
                <div class="list_text">
                  <div class="article_title">{{ review.title }}</div>
                  <div class="article_introduction">
                    <div class="ship_info">
                      {{ review.shipName }} | {{ review.sailDate }}
                    </div>
                    <div class="introduction">
                      {{ review.route }}
                    </div>
                  </div>
                  <div class="article_info fix">
                    <div class="f-fl author">
                      <i class="author_head">
                        <img
                          src="https://resource.rcclchina.com.cn/logo/PC/logoAvatarCircleBlueLarge.png"
                          style="width: 100%"
                        />
                      </i>
                      {{ review.author }}
                    </div>
                    <div
                      class="f-fr lick_num"
                      @click.stop="onUpvoteClick(review)"
                    >
                      <i
                        class="detail_ico_25"
                        :class="{ active: review.isUpvote }"
                      ></i
                      ><span>{{ review.score }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <LoginModal
      v-if="isShowLoginPopup"
      :onLoginSuccessHandler="onLoginSuccessHandler"
      :isShow="isShowLoginPopup"
      :redirectUri="currentUrl"
    />

    <SuiteStateroomPopup
        :suiteImage="specialBookingRuleImage"
        v-on:onModalClose="closeSpecialBookingPopup"
        :isShow="isShowSpecialBookingRuleImagePopup"
    />

    <EmergencyMessageAlert />

    <common-modal
      :isShow="isShowSpecialHKPopup"
      v-on:onModalClose="closeHKPopup"
    >
      <div>
        <p style="font-weight: bold; text-align: center;">2021年香港复航航次乘客要求</p>
        <p>
          根据政府相关指引以及卫生防控需要，乘客必须同时符合以下条件方可登船：
        </p>
        <p>1. 香港居民</p>
        <p>
          2.
          已在登船日14天前接种2剂新冠疫苗，持有医疗证明不适合接种疫苗或12周岁以下人士除外。
        </p>
        <p>3. 登船日前48小以内进行了核酸检测，且报告结果为阴性。</p>
        <p>4. 登船日前14天以内未到访或途经特区政府发出禁止来港极高风险地区。</p>
      </div>
    </common-modal>
  </div>
</template>

<script>
import api from "@/api";
import Cookies from "js-cookie";
import { isHkSpecialCruise } from "@/utilities/tools";
import { reportUserBrowsingRecord } from "@/utilities/common";
const BannerKV = () => import("@/components/BannerKV.vue");
const CruiseDetailCruiseInfo = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailCruiseInfo.vue");
const CruiseDetailStateroom = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailStateroom.vue");
const CruiseDetailNav = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailNav.vue");
const CruiseDetailFeatures = () =>
    import("@/components/Cruise/CruiseDetail/CruiseDetailFeatures.vue");
const CruiseDetailRoute = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailRoute.vue");
const CruiseDetailPolicy = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailPolicy.vue");
const LoginModal = () => import("@/components/User/LoginModal.vue");
const EmergencyMessageAlert = () =>
  import("@/components/Common/EmergencyMessageAlert");
const SuiteStateroomPopup = () =>
  import("@/components/Cruise/CruiseDetail/SuiteStateroomPopup.vue");
const CommonModal = () => import("@/components/Common/CommonModal");
const uCountDown = () => import("@/components/Cruise/uCountDown");
const CustomBannerSwiper = ()=> import("@/components/Common/CustomBannerSwiper.vue")
export default {
  name: "CruiseDetailRow",
  components: {
    BannerKV,
    CustomBannerSwiper,
    CruiseDetailCruiseInfo,
    CruiseDetailStateroom,
    CruiseDetailNav,
    CruiseDetailFeatures,
    CruiseDetailRoute,
    CruiseDetailPolicy,
    LoginModal,
    SuiteStateroomPopup,
    EmergencyMessageAlert,
    CommonModal,
    uCountDown
  },
  asyncData({ store, route, component }) {
    const shipCode = route.query.shipCode;
    const sailDate = route.query.sailDate;
    const userToken = store.state.user.userToken;
    return new Promise((resolve, reject) => {
      if (component.$loading) {
        component.$loading.show();
      }
      store.commit("SET_CRUISE_DETAIL_SAILING", { shipCode, sailDate });
      var tagSource = "online";
      if (store.state.user.pppKey && store.state.user.pppKey.length > 0) {
        tagSource = "PPP";
      }
      return api.cruise
        .getCruiseDetail({
          shipCode,
          sailDate,
          username: userToken,
          tagSource,
        })
        .then(({ success, data, errMsg }) => {
          if (!success) console.error(errMsg);
          store.commit("SET_CRUISE_DETAIL", { success, data });
          if (data.seoViewModel) {
            store.commit("SET_META", data.seoViewModel);
          }
          resolve();
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  data() {
    return {
      reviews: [],
      isShowLoginPopup: false,
      loginCallback: null,
      isShowSpecialBookingRuleImagePopup: false,
      isShowSpecialHKPopup: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      featuresUrls: [],
      vrUrl:'',
      couponsList:[],
      bannerIncludesBirthdayList: [], //banner含生日
      bannerIncludesBirthdayLoadedKey: '' //banner请求防重key（shipCode_sailDate），避免created+activated双调用重复请求
    };
  },
  activated() {
    this.getBannerIncludesBirthdayList();
  },
  beforeDestroy() {
    if (this.countDownTimer) {
      clearInterval(this.countDownTimer);
    }
  },
  created(){
    this.getAllCruiseFeature();
    this.getBannerIncludesBirthdayList();
  },
  methods: {
    async getAllCruiseFeature(){
      const { success,data,errMsg } = await api.cruise.getAllCruiseFeature();
      if(success) {
        this.featuresUrls = data;
      } else {
        this.$alert.show(errMsg);
      }
    },
    
    async getCruiseReviews() {
      let request = {
        shipCode: this.shipCode,
        sailDate: this.sailDate,
      };
      const { data } = await api.cruise.getCruiseReview(request);
      if (data && data.length > 0) {
        this.reviews = data;
      }
    },
    goReviewDetail(id) {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/Rccl.Review/Travel/d-n-n-0-0-${id}.html`
      );
    },
    async onUpvoteClick(review) {
      if (!this.userToken) {
        this.$alert.show('请先登录')
        return
      }
      if (review.isUpvote) {
        this.$alert.show("您已点过赞了");
      } else {
        this.$loading.show();
        const { success, errMsg } = await api.review.upvote({
          articalId: review.id
        });

        this.$loading.hide();
        if (!success) {
          this.$alert.show(errMsg);
          return;
        }
        review.score++;
        review.isUpvote = true;
      }
    },
    showLoginPopup(callback) {
      this.isShowLoginPopup = true;
      this.loginCallback = callback;
    },
    onLoginSuccessHandler() {
      this.isShowLoginPopup = false;
      if (this.loginCallback) {
        this.loginCallback();
        this.loginCallback = null;
      }
      this.getCoupons()
    },
    showSpecialBookingPopup() {
      this.isShowSpecialBookingRuleImagePopup = true;
    },
    closeSpecialBookingPopup() {
      this.isShowSpecialBookingRuleImagePopup = false;
    },
    closeHKPopup() {
      this.isShowSpecialHKPopup = false;
    },
    async getShipVrMiniSite() {
      let { success, data} = await api.cruise.getShipVrMiniSiteApi({
        shipCode: this.shipCode,
        pageKey:'CruiseDetail',
        source:'PC'
      });
      if(success){
        this.vrUrl = data.url;
      }
    },
    goVrMiniSite(){
      window.open(this.vrUrl)
    },
    
    async getCoupons() {
      console.log('getCoupons')
      const route = this.$router.currentRoute;
      const shipCode = route.query.shipCode;
      const sailDate = route.query.sailDate;
      const userToken = this.$store.state.user.userToken;
      this.$loading.show()
      const {success,data} = await api.booking.getRouteDetailCoupons({
        source: 'online',
        shipCode,
        sailDate,
        username: userToken,
      })
      this.$loading.hide()
      if(success){
        this.couponsList = data
      }
    },
    async getBannerIncludesBirthdayList() {
      const route = this.$router.currentRoute;
      const shipCode = route.query.shipCode;
      const sailDate = route.query.sailDate;
      // 防重：相同船期已成功加载过则跳过（created + activated 双调用场景避免重复请求）
      const key = `${shipCode}_${sailDate}`;
      if (this.bannerIncludesBirthdayLoadedKey === key) return;
      const { success,data } = await api.cruise.getCruisePromoBanner({
        shipCode,
        sailDate
      });
      if(success) {
        // 只有请求成功才记录key，失败时下次进入可重试
        this.bannerIncludesBirthdayLoadedKey = key;
        this.bannerIncludesBirthdayList = data?.map(r => {
          if(r.imagePc) {
            return {
              ...r,
              imageUrl: r.imagePc,
              isPointer: r.showType === "birthdayGift" || r.link
            }
          }
        }) ?? [];
      }
    },
    handleBannerToJump(banner) {
      if(banner.showType === "birthdayGift") {
        this.showSpecialBookingPopup();
      } else {
        if(banner.link) {
          window.open(banner.link)
        }
      }
    }
  },
  computed: {
    cruiseDetail() {
      return this.$store.state.cruise.cruiseDetail.data;
    },
    banners() {
      let banners = [];
      if (this.cruiseDetail && this.cruiseDetail.banners) {
        this.cruiseDetail.banners.forEach((banner) => {
          banners.push({
            image: banner,
          });
        });
      }
      return banners;
    },
    specialBooking() {
      if (
          this.cruiseDetail &&
          this.cruiseDetail.specialBookingViews &&
          this.cruiseDetail.specialBookingViews.length > 0
      ) {
        return this.cruiseDetail.specialBookingViews[0];
      }
      return {};
    },
    specialBookingRuleImage() {
      return this.specialBooking.mobileRuleDescriptionImage || "";
    },
    shipCode() {
      return this.$store.state.cruise.cruiseDetail.shipCode;
    },
    sailDate() {
      return this.$store.state.cruise.cruiseDetail.sailDate;
    },
    cruiseDetailSuccess() {
      return this.$store.state.cruise.cruiseDetail.success;
    },
    userToken() {
      return this.$store.state.user.userToken;
    },
    ports() {
      if (!this.cruiseDetail || !this.cruiseDetail.ports) {
        return [];
      }
      return this.cruiseDetail.ports;
    },
    departureCode() {
      let code = "";
      if (this.ports.length > 0) {
        code = this.ports[0].code;
      }
      return code;
    },
    portAddress() {
      if (this.ports.length == 0) return "";
      let portAddress = this.ports[0].portAddress;
      if (portAddress) {
        portAddress = portAddress.replace("地址：", "");
      }
      return portAddress;
    },
    shoppingCarts() {
      let shoppingCarts = this.$store.state.booking.shoppingCarts;
      if (shoppingCarts && shoppingCarts.length > 0) {
        return shoppingCarts.filter(
          (r) => r.shipCode == this.shipCode && r.sailDate == this.sailDate
        );
      }
      return [];
    },
    specialBookingInfo() {
      if (
        !this.cruiseDetail ||
        !this.cruiseDetail.specialBookingViews ||
        this.cruiseDetail.specialBookingViews.length <= 0
      ) {
        return {};
      }
      return this.cruiseDetail.specialBookingViews[0];
    },
    specialBookingInfos() {
      if (
        !this.cruiseDetail ||
        !this.cruiseDetail.specialBookingViews ||
        this.cruiseDetail.specialBookingViews.length <= 0
      ) {
        return [];
      }

      return this.cruiseDetail.specialBookingViews;
    },
    currentUrl() {
      return location.href
    },
    payShorexOnly() {
      return this.cruiseDetail?.payShorexOnly || false;
    }
  },
  watch: {
    cruiseDetailSuccess(newOne) {
      if (!newOne) {
        this.$router.go(-1);
      }
    },
    cruiseDetail(newValue) {
      console.log('cruiseDetail', newValue.cruiseId)
      this.getShipVrMiniSite()
      this.getCoupons()
      
      this.getCruiseReviews();
      if (newValue && newValue.cruiseId) {
        // 上报浏览航线记录
        reportUserBrowsingRecord({
          ProductType: 3,
          ProductId: newValue.cruiseId,
          SceneType: 1,
          Parameters: []
        });
        Cookies.set("CruiseIds", newValue.cruiseId, { expires: 14 });
        console.log('Cookies', Cookies.get("CruiseIds"))
        if (newValue.ports && newValue.ports.length > 0) {
          if (
            isHkSpecialCruise(
              newValue.shipCode,
              newValue.sailDate,
              newValue.ports[0].code
            )
          ) {
            this.isShowSpecialHKPopup = true;
          }
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.detailpage {
  background: #f5f5f5;
  padding-bottom: 20px;
  position: relative;
  z-index: 1;

  .banner {
    position: relative;
    z-index: 1;
  }

  .warp1200 {
    width: 1200px;
    margin: 0 auto;
  }

  .part_box {
    background: #fff;
    padding: 20px;
    border-bottom: 10px solid #f5f5f5;
    position: relative;
    // z-index: 1;
  }

  .roomInfo,
  #next_btn,
  .lick_num,
  .review {
    cursor: pointer;
  }

  .start_banner {
    position: relative;
    margin-bottom: 10px;
    height: 145px;
    overflow: hidden;

    img.start-banner-cover {
      position: relative;
      width: 100%;
    }
  }

  .part_section {
    position: absolute;
    top: -50px;
  }

  .part5 {
    position: relative;
    background: #fff;
    border-bottom: 15px #f5f5f5 solid;

    .blur_bd_title {
      position: absolute;
      top: 16px;
      left: -5px;
      width: 82px;
      padding: 10px 0px 20px;
      background: url(https://resource.rcclchina.com.cn/tui2/detail/part4_title_bj.png)
        no-repeat center;
      text-align: center;
      line-height: 78px;
      font-size: 20px;
      color: #fff;
      line-height: 1.2;
    }

    .travels_box {
      min-height: 200px;
      padding: 20px 20px 20px 100px;

      .list_box {
        cursor: pointer;
        margin-bottom: 10px;
        transition: box-shadow 0.3s ease;

        .list_img {
          width: 100%;
          height: 152px;
          overflow: hidden;

          img {
            width: 100%;
          }
        }

        .list_text {
          padding: 10px 10px 16px;
          background: #f5f5f5;
          color: #747d80;

          .article_title {
            font-size: 16px;
            color: #282b2c;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .article_introduction {
            padding: 4px 0px 10px;
            line-height: 1.6;

            .ship_info {
              margin-bottom: 4px;
            }

            .introduction {
              min-height: 44px;
            }
          }

          .article_info {
            line-height: 36px;

            .author_head {
              width: 36px;
              height: 36px;
              background-color: #000d56;
              border-radius: 50%;
              display: inline-block;
              vertical-align: middle;
              margin-right: 6px;
            }

            .lick_num span {
              display: inline-block;
              vertical-align: middle;
              line-height: 25px;
            }
          }
        }
      }

      .list_box:hover {
        box-shadow: 0px 0px 7px 3px rgba(46, 65, 80, 0.1);
      }
    }
  }
}
.vrBanner{
  width: 100%;
  height: 162px;
  padding-bottom: 30px;
  margin-bottom: 15px;
  background-color: #fff;
  & img{
    width: 100%;
    height: 132px;
  }
}
.countdown-main {
  width: 100%;
  height: 86px;
  background: url("https://resource.rcclchina.com.cn/cruiseDetail/pc/pc-bg.png") no-repeat;
  background-size: 100%;
  margin: 4px 0 16px;
  padding: 12px 40px 14px 18px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  & .countdown-main-left {
    width: 75%;
    & .title-con {
      display: flex;
      align-items: center;
      gap: 5px;
      color: #FFFFFF;
      margin-bottom: 15px;
      & .text {
        font-size: 26px;
        font-weight: 500;
        line-height: 26px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: calc(100% - 28px - 5px);
      }
      & img {
        width: 28px;
        height: 29px;
        display: block;
      }
    }
    & .desc-con {
      font-weight: 500;
      max-width: 100%;
      & div {
        font-size: 18px;
        color: #FFFFFF;
        line-height: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .countdown-main-right {
    font-size: 24px;
    text-align: right;
    & .right-label {
      text-align: center;
      border-top: 1px solid #fff;
      margin: 0 auto;
      padding: 0;
      min-width: 180px;
      & legend{
        margin: 0 ;
        padding: 0 6px;
        border: none;
        width: auto;
        font-size: 24px;
        line-height: 24px;
        color: #fff;
      }
    }
    & .right-time {
      width: 100%;
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
      line-height: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 5px;
      margin-top: 12px;
      & span {
        font-weight: 500;
        font-size: 20px;
        color: #DB0100;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 6px 5px;
      }
    }
  }
}
.salesCountdownBox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 3px;
  position: absolute;
  top: 20px;
  left: 50px;
  z-index: 2;
  padding: 8px 8px;
  border-radius: 4px;
  background-color: #FA531F;
  .barDesc {
    font-size: 18px;
    height: 13px;
    line-height: 13px;
    color: #fff;
  }
}
</style>
